import type { ICrossOriginCommunicator } from './types';
import { IntegrationApi } from './types';

export const importCommunicator = (integration: string): Promise<ICrossOriginCommunicator> => {
  switch (integration) {
    case IntegrationApi.PaddyPower:
      return import('./paddypower/CrossOriginCommunicationPaddyPower').then((module) => module.default);
    case IntegrationApi.SkyVegas:
      return import('./SkyVegas/CrossOriginCommunicationSkyVegas').then((module) => module.default);
    case IntegrationApi.BridgeApi:
      return import('./bridgeapi/CrossOriginCommunicationBridgeApi').then((module) => module.default);
    case IntegrationApi.DBOX:
      return import('./DBOX/CrossOriginCommunicationDBOX').then((module) => module.default);
    case IntegrationApi.GGNet:
      return import('./GGNet/CrossOriginCommunicationGGNet').then((module) => module.default);
    case IntegrationApi.Default:
    case IntegrationApi.Empty:
      return import('./default/CrossOriginCommunicationDefault').then((module) => module.default);
    default:
      return Promise.reject(new Error(integration));
  }
};
